
import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Menu from './components/Menu';
import MenuItemDetail from './components/MenuItemDetail';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import FloatingActions from './components/FloatingActions';
import Preloader from './components/Preloader';
import VersionChecker from './components/VersionChecker';
import AccessibilityStatement from './components/AccessibilityStatement';
import { LanguageProvider } from './components/LanguageContext';

// Helper component to scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

// Wrapper for animated routes
const AnimatedRoutes = () => {
  const location = useLocation();
  
  return (
    <div key={location.pathname} className="page-transition">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/story" element={<About />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/menu/:id" element={<MenuItemDetail />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/accessibility" element={<AccessibilityStatement />} />
      </Routes>
    </div>
  );
};

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    // Start exit animation after 1s
    const exitTimer = setTimeout(() => {
      setIsExiting(true);
    }, 1000);

    // Remove preloader from DOM after animation completes (1s + 0.7s buffer)
    const removeTimer = setTimeout(() => {
      setIsLoading(false);
    }, 1700);

    return () => {
      clearTimeout(exitTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  return (
    <LanguageProvider>
      {isLoading && <Preloader isExiting={isExiting} />}
      <Router>
        <ScrollToTop />
        <div className="min-h-screen bg-fait-dark text-fait-cream font-sans selection:bg-fait-gold selection:text-fait-dark flex flex-col">
          {/* Skip to Content Link for Accessibility */}
          <a 
            href="#main-content" 
            className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:bg-fait-gold focus:text-fait-dark focus:px-4 focus:py-2 focus:rounded-md focus:font-bold"
          >
            דלג לתוכן / Skip to Content
          </a>

          <Navbar />
          <FloatingActions />
          <VersionChecker />
          <main id="main-content" className="flex-grow focus:outline-none" tabIndex={-1}>
            <AnimatedRoutes />
          </main>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
